import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of North Carolina",
  shortName: "BCBSNC",
  slug: "bcbsnc-insurance",
  seoTitle:
    "Blue Cross Blue Shield of North Carolina (BCBSNC) TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of North Carolina (BCBSNC) policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBSNC TMS coverage, Blue Cross Blue Shield North Carolina SPRAVATO authorization, BCBSNC mental health benefits Coral Springs FL, BCBSNC depression treatment Florida",
};

export const BcbsncInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsncInsurance;
